/*
 * Copyright (c) 2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {
    AfterViewChecked,
    ElementRef,
    HostBinding,
    Injectable,
    Injector,
    OnDestroy,
    Renderer2,
    SkipSelf
} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';

import {IfOpenService} from '../../utils/conditional/if-open.service';

import {Point, Popover, PopoverOptions} from './popover';
/**
 * @abstract
 */
export abstract class AbstractPopover implements AfterViewChecked, OnDestroy {
/**
 * @param {?} injector
 * @param {?} parentHost
 */
constructor(injector: Injector,  protected parentHost: ElementRef) {
        this.el = injector.get(ElementRef);
        this.ifOpenService = injector.get(IfOpenService);
        this.renderer = injector.get(Renderer2);
        // Default anchor is the parent host
        this.anchorElem = parentHost.nativeElement;

        this.popoverInstance = new Popover(this.el.nativeElement);
        this.subscription = this.ifOpenService.openChange.subscribe((change) => {
            change ? this.anchor() : this.release();
        });
        if (this.ifOpenService.open) {
            this.anchor();
        }
    }

    protected el: ElementRef;
    protected ifOpenService: IfOpenService;
    protected renderer: Renderer2;
private popoverInstance: Popover;
private subscription: Subscription;
private updateAnchor = false;

    protected anchorElem: any;
    protected anchorPoint: Point;
    protected popoverPoint: Point;
    protected popoverOptions: PopoverOptions = {};
/**
 * @return {?}
 */
protected anchor() {
        this.updateAnchor = true;
        // Ugh
        this.ignore = this.ifOpenService.originalEvent;
    }
/**
 * @return {?}
 */
protected release() {
        this.detachOutsideClickListener();
        this.popoverInstance.release();
    }
/**
 * @return {?}
 */
ngAfterViewChecked() {
        if (this.updateAnchor) {
            this.updateAnchor = false;
            this.popoverInstance.anchor(this.anchorElem, this.anchorPoint, this.popoverPoint, this.popoverOptions)
                .subscribe(() => {
                    // if a scroll event is detected, close the popover
                    this.ifOpenService.open = false;
                });
            this.attachOutsideClickListener();
        }
    }
/**
 * @return {?}
 */
ngOnDestroy() {
        this.release();
        this.subscription.unsubscribe();
    }
/**
 * @return {?}
 */
get isOffScreen() {
        return this.ifOpenService.open ? false : true;
    }
public closeOnOutsideClick = false;
private hostListener: () => void;
private documentListener: () => void;
private ignore: any;
/**
 * @return {?}
 */
private attachOutsideClickListener() {
        if (this.closeOnOutsideClick) {
            this.hostListener = this.renderer.listen(this.el.nativeElement, "click", event => this.ignore = event);
            this.documentListener = this.renderer.listen("document", "click", event => {
                if (event === this.ignore) {
                    delete this.ignore;
                } else {
                    this.ifOpenService.open = false;
                }
            });
        }
    }
/**
 * @return {?}
 */
private detachOutsideClickListener() {
        if (this.closeOnOutsideClick) {
            if (this.hostListener) {
                this.hostListener();
                delete this.hostListener;
            }
            if (this.documentListener) {
                this.documentListener();
                delete this.documentListener;
            }
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Injector, },
{type: ElementRef, decorators: [{ type: SkipSelf }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'isOffScreen': [{ type: HostBinding, args: ["class.is-off-screen", ] },],
};
}

function AbstractPopover_tsickle_Closure_declarations() {
/** @type {?} */
AbstractPopover.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AbstractPopover.ctorParameters;
/** @type {?} */
AbstractPopover.propDecorators;
/** @type {?} */
AbstractPopover.prototype.el;
/** @type {?} */
AbstractPopover.prototype.ifOpenService;
/** @type {?} */
AbstractPopover.prototype.renderer;
/** @type {?} */
AbstractPopover.prototype.popoverInstance;
/** @type {?} */
AbstractPopover.prototype.subscription;
/** @type {?} */
AbstractPopover.prototype.updateAnchor;
/** @type {?} */
AbstractPopover.prototype.anchorElem;
/** @type {?} */
AbstractPopover.prototype.anchorPoint;
/** @type {?} */
AbstractPopover.prototype.popoverPoint;
/** @type {?} */
AbstractPopover.prototype.popoverOptions;
/** @type {?} */
AbstractPopover.prototype.closeOnOutsideClick;
/** @type {?} */
AbstractPopover.prototype.hostListener;
/** @type {?} */
AbstractPopover.prototype.documentListener;
/** @type {?} */
AbstractPopover.prototype.ignore;
/** @type {?} */
AbstractPopover.prototype.parentHost;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
